document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

function syncProductVariant(selector) {
  const form = selector.closest('form');
  const selected = selector.options[selector.selectedIndex];
  const priceTarget = document.querySelector('[data-product-price]');
  const stickyPriceTarget = document.querySelector('[data-sticky-product-price]');
  const mainImage = document.querySelector('.product__main-image img');

  if (selected) {
    document.querySelectorAll('[data-product-variant-id]').forEach((idInput) => {
      idInput.value = selected.value;
      if (selected.dataset.variantImage) {
        idInput.dataset.variantImage = selected.dataset.variantImage;
      }
    });
  }

  if (priceTarget && selected?.dataset.price) {
    priceTarget.textContent = selected.dataset.price;
  }

  if (stickyPriceTarget && selected?.dataset.price) {
    stickyPriceTarget.textContent = selected.dataset.price;
  }

  if (selected?.dataset.variantImage && mainImage) {
    mainImage.src = selected.dataset.variantImage;
    mainImage.srcset = '';
  }

  document.querySelectorAll('[name="add"]').forEach((button) => {
    const available = selected?.dataset.variantAvailable !== 'false';
    button.disabled = !available;
    if (button.classList.contains('sticky-atc__button')) {
      button.textContent = available ? 'Add to cart' : 'Sold out';
    }
  });
}

document.addEventListener('change', (event) => {
  const autoSubmit = event.target.closest('[data-auto-submit]');
  if (autoSubmit) {
    autoSubmit.form?.submit();
    return;
  }

  const variantSelector = event.target.closest('[data-variant-selector]');
  if (!variantSelector) return;

  syncProductVariant(variantSelector);
});

document.querySelectorAll('[data-variant-selector]').forEach((selector) => {
  syncProductVariant(selector);
});

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-mobile-menu-toggle]');
  if (!toggle) return;

  const menu = document.getElementById(toggle.getAttribute('aria-controls'));
  const expanded = toggle.getAttribute('aria-expanded') === 'true';

  toggle.setAttribute('aria-expanded', String(!expanded));
  menu?.classList.toggle('is-open', !expanded);
});

document.querySelectorAll('product-recommendations[data-url]').forEach(async (container) => {
  if (container.dataset.loaded === 'true') return;

  try {
    const response = await fetch(container.dataset.url);
    const text = await response.text();
    const html = new DOMParser().parseFromString(text, 'text/html');
    const recommendations = html.querySelector('product-recommendations');

    if (recommendations?.innerHTML.trim()) {
      container.innerHTML = recommendations.innerHTML;
      container.dataset.loaded = 'true';
    }
  } catch (error) {
    container.dataset.loaded = 'false';
  }
});
